/**
 *
 * UserHeaderBox
 *
 */

import "./index.less"

import {
  DAEMON,
  ROLE_AMBASSADOR,
  ROLE_LEADER,
  ROLE_MANDU_ADMIN,
  ROLE_MANDU_SUPER_ADMIN,
} from "utils/constants"
import { Divider, Spin } from "antd"
import { find, isEqual } from "lodash"
import { getUserWatcher, logoutWatcher, uploadLogoWatcher } from "./actions"
import { makeSelectIsLoading, makeSelectUsername } from "./selectors"

import { LOCAL_ACTIVE_ROL } from "../../utils/storage"
import { LoadingOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import React from "react"
import UserBox from "../../components/UserBox"
import { compose } from "redux"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import reducer from "./reducer"
import saga from "./saga"

/* eslint-disable react/prefer-stateless-function */
export class UserHeaderBox extends React.Component {
  state = { srcLogo: "" }

  UNSAFE_componentWillMount() {
    this.props.onMount()
  }

  componentDidMount() {
    const {
      dataObject: { companies },
    } = this.props

    if (companies && companies.logo !== "none") {
      this.setState({ srcLogo: companies.logo })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      dataObject,
      dataObject: { companies },
    } = this.props

    if (!isEqual(prevProps.dataObject, dataObject)) {
      if (companies.logo !== "none") {
        this.setState({ srcLogo: companies.logo })
      }
    }
  }

  selectImageLogo = (event) => {
    const reader = new FileReader()

    if (!event.target.files[0]) return

    if (event.target.files[0].size <= 1024 * 1024 * 2) {
      const fd = new FormData()
      fd.append("uploaded_file", event.target.files[0])
      this.props.uploadLogoWatcher(fd)
    } else {
      return window.message.error("Error al cargar logo.", 5)
    }

    reader.onload = () => {
      if (reader.result.includes("image")) {
        this.setState({ srcLogo: reader.result })
      } else {
        window.message.error("Error al cargar logo.", 5)
      }
    }

    reader.readAsDataURL(event.target.files[0])
  }

  getLogoCompany = () => {
    const { dataObject } = this.props
    if (!dataObject) return null
    return dataObject.companies.logo
  }

  validateAdminManduRole = () => {
    const id_role = LOCAL_ACTIVE_ROL()
    const route = `${window.location.origin}/`

    return (
      [ROLE_MANDU_SUPER_ADMIN.toString(), ROLE_MANDU_ADMIN.toString()].includes(
        id_role
      ) && process.env.ADMIN_URL == route
    )
  }

  render() {
    const { dataObject } = this.props
    const antIcon = (
      <LoadingOutlined className="container-userheaderbox__loader" />
    )

    return (
      <React.Fragment>
        <UserBox {...this.props} logout={this.props.onLogout} />

        {this.props.isLoading && <Spin size="large" indicator={antIcon} />}

        {!!dataObject &&
          !this.props.isLoading &&
          (this.getLogoCompany() ? (
            this.validateAdminManduRole() ? null : (
              <React.Fragment>
                <Divider
                  type="vertical"
                  className="container-userheaderbox__divider"
                />
                <img
                  alt="logo"
                  src={this.getLogoCompany()}
                  className="container-userheaderbox__logo-company"
                />
              </React.Fragment>
            )
          ) : this.validateAdminManduRole() ||
            LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR ||
            LOCAL_ACTIVE_ROL() == ROLE_LEADER ? null : (
            <React.Fragment>
              <Divider
                type="vertical"
                className="container-userheaderbox__divider"
              />
              <div
                className="container-userheaderbox__add-logo"
                onClick={() => this.fileInputSelectLogo.click()}>
                + Añadir logo
              </div>
            </React.Fragment>
          ))}
        <input
          style={{ display: "none" }}
          type="file"
          accept="image/*"
          onChange={this.selectImageLogo}
          ref={(fileInputSelectLogo) =>
            (this.fileInputSelectLogo = fileInputSelectLogo)
          }
        />
      </React.Fragment>
    )
  }
}

UserHeaderBox.propTypes = { onMount: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  dataObject: makeSelectUsername(),
  isLoading: makeSelectIsLoading(),
})

function mapDispatchToProps(dispatch) {
  return {
    onMount: () => dispatch(getUserWatcher()),
    onLogout: () => dispatch(logoutWatcher()),
    uploadLogoWatcher: (params) => dispatch(uploadLogoWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "userHeaderBox", reducer })
const withSaga = injectSaga({ key: "userHeaderBox", saga, mode: DAEMON })

export default compose(withReducer, withSaga, withConnect)(UserHeaderBox)
